import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getOrder } from "../store/order/selectors.js";
import { getFlight } from "../store/flightDetails/selectors.js";
export default function useATOL() {
    const order = useSelector(getOrder);
    const flight = useSelector(getFlight);
    const airOrderSegments = order?.airOrder?.flightSegments;
    const flightDetailsSegments = flight?.segments;
    const orderToken = order?.orderToken;
    const isATolProtectedSR = useCallback((atolProtectedStatus) => {
        return Boolean(atolProtectedStatus && atolProtectedStatus !== "NONE");
    }, []);
    const isATolProtectedFD = useCallback((flight) => {
        return flight.segments.some(({ isAtolProtected }) => isAtolProtected);
    }, []);
    const isATolProtectedCheckOut = useCallback(() => {
        const segments = airOrderSegments || flightDetailsSegments || [];
        return segments.some(({ isAtolProtected }) => isAtolProtected);
    }, [flightDetailsSegments, airOrderSegments]);
    const getAtolPdfUrl = useCallback(() => {
        return orderToken ? `/api/order/${orderToken}/documents/atol-certificate?downloadable=1` : undefined;
    }, [orderToken]);
    return {
        isATolProtectedSR,
        isATolProtectedFD,
        isATolProtectedCheckOut,
        getAtolPdfUrl
    };
}
